import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import Point from 'ol/geom/Point';
import WKT from 'ol/format/WKT';
import GeoJSON from 'ol/format/GeoJSON';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Fill, Stroke, Style, Text } from 'ol/style';
import { extend, createEmpty } from 'ol/extent';
import AreaCodeHolder from '@/common/areaCodeHolder.js';
import mapConfig from '@/data/mapConfig.js';
// import { getCenterByExtent } from '@/utils/common.js';
import Service from '@/service/index.js';

export default {
  data: () => {
    return {
      mapConfig,
      mapConfigData: {},
      code: '',
      codeLevelMap: {
        1: 4,
        2: 6,
        3: 6
      },
      colorList: ['#ffe4ad', '#fea444', '#44ddff', '#e75bfc', '#49ffac', '#ff7ea7', '#ffdc41', '#42ff34', '#ff8f85', '#b35cf0', '#3bdfbf', '#33b8f1'],
      map: null,
      baseLayer: null,
      hoverLayer: null,
      source4: null
    };
  },
  mounted () {
    this.hostList = window.location.host.split('.');
    this.goToInitMap();
  },
  methods: {
    goToInitMap () {
      this.code = AreaCodeHolder.getInstance().areaCode;
      this.level = AreaCodeHolder.getInstance().level;
      if (this.code === '451022') {
        this.mapConfigData = this.mapConfig.tiandong;
      } else {
        this.mapConfigData = this.mapConfig['region' + AreaCodeHolder.getInstance().level];
      }
      this.initMap(this.code);
      this.map.on('singleclick', this.mapClickHandler);
      this.map.on('pointermove', this.mapMoveHandler);
      console.log('goToInitMap');
    },
    getNameByAreaCode (areaCode) {
      Service.getNameByAreaCode(areaCode).then(({ code, data, reason }) => {
        if (code === '0') {
          this.openNewUrl(data);
        } else {
          this.$errorMessage(reason);
        }
      });
    },
    openNewUrl (name) {
      console.log(this.hostList, 'hostList');
      if (this.hostList.includes('dev')
        || this.hostList.includes('test')
        || this.hostList.includes('gxcqjyzx')
        || this.hostList.includes('stage')
        || this.hostList.includes('localhost:8002')) {

        if (this.hostList.includes('com')) {
          window.open('https://' + name + '.gxcqjyzx.com');
        } else {
          window.open('http://' + name + '.gxcqjyzx.cn');
        }

      } else {
        if (this.hostList.includes('com')) {
          window.open('https://' + name + '.gxcqjyzx.com');
        } else {
          window.open('http://' + name + '.gxcqjyzx.cn');
        }
      }
    },
    mapClickHandler (evt) {
      if (this.level >= 3) {
        return;
      }
      const feature = this.map.forEachFeatureAtPixel(evt.pixel,
        function (feature) {
          return feature;
        }
      );

      if (feature) {
        const info = feature.getProperties();
        const length = this.codeLevelMap[this.level];
        let areaCode = String(info[this.mapConfigData.code]).substr(0, length);
        this.$store.commit('SET_SHOW_AREA_CODE', areaCode);
        console.log(feature, areaCode, 'feature');
        this.getNameByAreaCode(areaCode);
      }
    },
    mapClickHandler2 (evt) {
      // const screenXY = evt.pixel;
      const point = new Point([evt.coordinate[0], evt.coordinate[1]]);
      const cql_filter = `INTERSECTS (the_geom,${new WKT().writeGeometry(point)})`;
      const params = {
        srsName: 'EPSG:3857',
        service: 'WFS',
        version: '1.0.0',
        request: 'GetFeature',
        typename: this.mapConfigData.layer,
        CQL_FILTER: cql_filter,
        outputFormat: 'application/json'
      };
      Service.get(this.mapConfig.owsUrl, params).then((response) => {
        const featureList = new GeoJSON().readFeatures(response);
        if (featureList.length) {
          const info = featureList[0].getProperties();
          this.$emit('mapClick', info);
        }
        evt.preventDefault();
      });
    },
    mapMoveHandler (e) {
      this.hoverLayer.getSource().clear();
      const featureList = this.source4.getFeaturesAtCoordinate(e.coordinate);
      this.hoverLayer.getSource().addFeatures(featureList);
      if (featureList && featureList.length) {
        this.map.getTargetElement().style.cursor = 'pointer';
      } else {
        this.map.getTargetElement().style.cursor = 'auto';
      }
    },
    initMap (code) {
      const source4 = new VectorSource();
      const baseLayer = new VectorLayer({
        source: source4,
        style: (feature) => {
          const name = feature.getProperties()[this.mapConfigData.name];
          return new Style({
            fill: new Fill({
              color: feature.getProperties().color
            }),
            stroke: new Stroke({
              color: '#9DC3E4',
              width: 1
            }),
            text: new Text({
              overflow: false,
              text: name,
              font: `bold ${Math.max(3, Math.floor(this.map.getView().getZoom() * 1))}px serif`,
              fill: new Fill({
                color: '#000000'
              })
            })
          });
        }
      });
      const hoverLayer = new VectorLayer({
        source: new VectorSource(),
        zIndex: 20,
        style: new Style({
          fill: new Fill({
            color: [0, 62, 219, 0.5]
          }),
          stroke: new Stroke({
            color: [0, 239, 253, 1.0],
            width: 1
          })
        })
      });
      this.map = new Map({
        target: 'map',
        controls: [],
        view: new View({
          projection: 'EPSG:3857',
          zoom: 7,
          maxZoom: 15,
          minZoom: 1
        }),
        layers: [baseLayer, hoverLayer]
      });
      this.baseLayer = baseLayer;
      this.hoverLayer = hoverLayer;
      this.source4 = source4;
      this.getGisData(code);
    },
    getGisData (code) {
      const length = this.codeLevelMap[this.level];
      let areaCode = code.substr(0, length) + '';
      areaCode = parseInt(areaCode);
      const params = {
        srsName: 'EPSG:3857',
        service: 'WFS',
        version: '1.0.0',
        request: 'GetFeature',
        typename: this.mapConfigData.layer,
        outputFormat: 'application/json'
      };

      if (code && this.level !== 1 && this.code !== '451022') {
        params.CQL_FILTER = `${this.mapConfigData.code} like '%${areaCode}%'`;
      }
      Service.get(this.mapConfig.owsUrl, params).then((response) => {
        const featureList = new GeoJSON().readFeatures(response);
        featureList.forEach((item, index) => {
          item.setProperties({
            color: this.getColorByIndex(index, this.colorList)
          });
        });
        this.source4.addFeatures(featureList);
        let extent = this.getExtentOfFeatures(featureList);
        this.map.getView().fit(extent);
      });
    },
    getColorByIndex (index, colorList) {
      const length = colorList.length;
      return colorList[index % length];
    },
    getExtentOfFeatures (features) {
      let extents = features.map(feature => {
        return feature.getGeometry().getExtent();
      });
      let extent = createEmpty();
      extents.forEach((ex) => {
        extent = extend(extent, ex);
      });
      return extent;
    }
  }
};
